import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { PleasewaitPopup } from "./PleasewaitPopup";
import Select from "react-select";
import { getContentBySubLesson, getVideoBySubLesson } from "../services/SubLesson";
import { post_Practice } from "../services/Practice";
import { post_Quize, post_QuizRelatedExcerices } from "../services/Quize";
import {
    DndContext,
    closestCenter,
    PointerSensor,
    useSensor,
    useSensors,
    TouchSensor,
} from "@dnd-kit/core";
import {
    arrayMove,
    SortableContext,
    useSortable,
    verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

type Answer = {
    id?: number;
    _uid: string;
    questionId: number;
    answerText: string;
    isCorrect: boolean;
    orderNumber: number;
    createdAt: string;
    createdBy: string;
    updatedAt: string;
    updatedBy: string;
};

type Question = {
    id?: number;
    _uid: string;
    subLessonId: number;
    quizId: number;
    questionText: string;
    questioType: string;
    explanationText: string;
    orderNumber: number;
    createdAt: string;
    createdBy: string;
    updatedAt: string;
    updatedBy: string;
    answers: Answer[];
};

type Quiz = {
    id?: number;
    subLessonId: number;
    title: string;
    description: string;
    orderNumber?: number;
    createdAt?: string;
    createdBy?: string;
    updatedAt?: string;
    updatedBy?: string;
    questions: Question[];
};

type Video = { id: number; title: string };
type Content = { id: number; title: string; contentUrl: string };
type Exercise = {
    id?: number;
    subLessonId: number;
    title: string;
    description: string;
    quizId?: number;
    videoIds?: number[];
    contentIds?: number[];
};

type AddPracticeProps = {
    showPopup: boolean;
    setShowPopup: (value: boolean) => void;
    setRefreshPracticeList: (value: boolean) => void;
    subLessonId: number;
}

const generateUID = () => `id-${Math.random().toString(36).substr(2, 9)}`;

// Question input
function QuestionInput({ qindex, value, onCommit }: any) {
    const [localValue, setLocalValue] = useState(value);
    useEffect(() => setLocalValue(value), [value]);
    return (
        <input
            type="text"
            value={localValue}
            placeholder={`Question ${Number(qindex) + 1}`}
            onChange={(e) => setLocalValue(e.target.value)}
            onBlur={() => onCommit(localValue)}
            className="border p-2 w-full rounded bg-white"
        />
    );
}

// Answer input
function AnswerInput({ aindex, value, questionType, isCorrect, onCommit, onToggleCorrect }: any) {
    const [localValue, setLocalValue] = useState(value);
    useEffect(() => setLocalValue(value), [value]);
    return (
        <div className="flex flex-col sm:flex-row sm:items-center gap-2 mb-2 p-2 rounded border bg-white w-full">
            <input
                type="text"
                value={localValue}
                onChange={(e) => setLocalValue(e.target.value)}
                placeholder={`Answer ${Number(aindex) + 1}`}
                onBlur={() => onCommit(localValue)}
                className="border p-2 flex-1 rounded bg-white w-full"
            />

            <div className="flex items-center gap-2 sm:mt-0 mt-1">
                {questionType === "SingleChoice" ? (
                    <input
                        type="radio"
                        className="cursor-pointer"
                        checked={isCorrect}
                        onChange={onToggleCorrect}
                    />
                ) : (
                    <input
                        type="checkbox"
                        className="cursor-pointer"
                        checked={isCorrect}
                        onChange={onToggleCorrect}
                    />
                )}

                <span className="text-sm text-gray-400 whitespace-nowrap">
                    Correct Answer
                </span>
            </div>
        </div>

    );
}

export const AddPractice = ({ showPopup, setShowPopup, setRefreshPracticeList, subLessonId }: AddPracticeProps) => {
    const userId = Cookies.get("userId-elministry") || "";
    const sensors = useSensors(
        useSensor(PointerSensor, {
            activationConstraint: { distance: 8 },
        }),
        useSensor(TouchSensor, {
            activationConstraint: {
                delay: 250,
                tolerance: 8,
            },
        })
    );
    const [exercise, setExercise] = useState<Exercise>({
        subLessonId: subLessonId,
        title: "",
        description: "",
        quizId: undefined,
        videoIds: [],
        contentIds: [],
    });

    const [videos, setVideos] = useState<Video[]>([]);
    const [contents, setContents] = useState<Content[]>([]);
    const [formQuiz, setFormQuiz] = useState<Quiz>({
        subLessonId: subLessonId,
        title: "",
        description: "",
        questions: [],
    });
    const [showPleasewait, setShowPleasewait] = useState<boolean>(false);
    const [dragScrollStop, setDragScrollStop] = useState(false);

    useEffect(() => {
        if (showPopup) {
            document.body.classList.add("overflow-hidden");
        } else {
            document.body.classList.remove("overflow-hidden");
        }

        return () => {
            document.body.classList.remove("overflow-hidden");
        };
    }, [showPopup]);

    useEffect(() => {
        if (subLessonId) {
            getVideoBySubLesson(subLessonId)
                .then((data) => {
                    setVideos(data);
                })
                .catch((error) => {
                    console.error(error)
                })

            getContentBySubLesson(subLessonId)
                .then((data) => {
                    setContents(data)
                })
                .catch((error) => {
                    console.log(error);
                })
        }
    }, [subLessonId])

    function SortableItem({ id, children }: any) {
        const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });
        const style = { transform: CSS.Transform.toString(transform), transition };
        return (
            <div
                ref={setNodeRef}
                style={style}
                className={`flex gap-2 ${dragScrollStop ? "touch-none" : ""} items-center`}
            >
                <div
                    {...attributes}
                    {...listeners}
                    onTouchStart={() => {

                        setDragScrollStop(true)
                    }}
                    onClick={() => {

                        setDragScrollStop(true)
                    }}
                    className={`cursor-grab p-2 touch-manipulation ${dragScrollStop ? "touch-none" : ""} select-none`}
                >
                    <span className="material-symbols-outlined text-gray-400">drag_indicator</span>
                </div>
                <div className="flex-1 flex items-center">{children}</div>
            </div>
        );
    }

    // Drag end for questions
    const handleQuestionDragEnd = (event: any) => {
        setDragScrollStop(false)
        const { active, over } = event;
        if (!over) return;

        const oldIndex = formQuiz.questions.findIndex(q => q._uid === active.id);
        const newIndex = formQuiz.questions.findIndex(q => q._uid === over.id);
        if (oldIndex === -1 || newIndex === -1) return;

        const questions = arrayMove(formQuiz.questions, oldIndex, newIndex);
        questions.forEach((q, i) => (q.orderNumber = i + 1));
        setFormQuiz(prev => ({ ...prev, questions }));
    };

    // Drag end for answers
    const handleAnswerDragEnd = (event: any, qIndex: number) => {
        setDragScrollStop(false)
        const { active, over } = event;
        if (!over) return;

        const q = formQuiz.questions[qIndex];
        const oldIndex = q.answers.findIndex(a => a._uid === active.id);
        const newIndex = q.answers.findIndex(a => a._uid === over.id);
        if (oldIndex === -1 || newIndex === -1) return;

        const answers = arrayMove(q.answers, oldIndex, newIndex);
        answers.forEach((a, i) => (a.orderNumber = i + 1));

        const updatedQuestions = [...formQuiz.questions];
        updatedQuestions[qIndex].answers = answers;
        setFormQuiz(prev => ({ ...prev, questions: updatedQuestions }));
    };

    if (!showPopup) return null;

    const videoOptions = videos.map((v) => ({ value: v.id, label: v.title }));
    const contentOptions = contents.map((c) => ({ value: c.id, label: c.title }));

    const handleQuestionChange = (qIndex: number, value: string) => {
        const updated = [...formQuiz.questions];
        updated[qIndex] = { ...updated[qIndex], questionText: value };
        setFormQuiz(prev => ({ ...prev, questions: updated }));
    };

    const handleAnswerChange = (qIndex: number, aIndex: number, value: string) => {
        const updated = [...formQuiz.questions];
        const answers = [...updated[qIndex].answers];
        answers[aIndex] = { ...answers[aIndex], answerText: value };
        updated[qIndex] = { ...updated[qIndex], answers };
        setFormQuiz(prev => ({ ...prev, questions: updated }));
    };

    const toggleAnswerCorrect = (qIndex: number, aIndex: number) => {
        const updated = [...formQuiz.questions];
        const q = updated[qIndex];
        if (q.questioType === "SingleChoice") {
            q.answers = q.answers.map((a, idx) => ({ ...a, isCorrect: idx === aIndex }));
        } else {
            q.answers[aIndex].isCorrect = !q.answers[aIndex].isCorrect;
        }
        setFormQuiz(prev => ({ ...prev, questions: updated }));
    };


    const addAnswer = (qIndex: number) => {
        const updated = [...formQuiz.questions];
        const newAnswer: Answer = {
            _uid: generateUID(),
            questionId: 0,
            answerText: "",
            isCorrect: false,
            orderNumber: updated[qIndex].answers.length + 1,
            createdAt: new Date().toISOString(),
            createdBy: userId,
            updatedAt: new Date().toISOString(),
            updatedBy: userId,
        };
        updated[qIndex].answers.push(newAnswer);
        setFormQuiz({ ...formQuiz, questions: updated });
    };

    const addQuestion = () => {
        const newQuestion: Question = {
            subLessonId: formQuiz.subLessonId,
            _uid: generateUID(),
            quizId: formQuiz.id ?? 0,
            questionText: "",
            questioType: "SingleChoice",
            explanationText: "",
            orderNumber: formQuiz.questions.length + 1,
            createdAt: new Date().toISOString(),
            createdBy: userId,
            updatedAt: new Date().toISOString(),
            updatedBy: userId,
            answers: [
                {
                    questionId: 0,
                    _uid: generateUID(),
                    answerText: "",
                    isCorrect: false,
                    orderNumber: 1,
                    createdAt: new Date().toISOString(),
                    createdBy: userId,
                    updatedAt: new Date().toISOString(),
                    updatedBy: userId,
                },
                {
                    questionId: 0,
                    _uid: generateUID(),
                    answerText: "",
                    isCorrect: false,
                    orderNumber: 2,
                    createdAt: new Date().toISOString(),
                    createdBy: userId,
                    updatedAt: new Date().toISOString(),
                    updatedBy: userId,
                },
            ],
        };
        setFormQuiz({ ...formQuiz, questions: [...formQuiz.questions, newQuestion] });
    };


    const deleteQuestion = (qIndex: number) => {
        const updated = [...formQuiz.questions];
        updated.splice(qIndex, 1);
        updated.forEach((q, idx) => (q.orderNumber = idx + 1));
        setFormQuiz({ ...formQuiz, questions: updated });
    };

    const deleteAnswer = (qIndex: number, aIndex: number) => {
        const updated = [...formQuiz.questions];
        updated[qIndex].answers.splice(aIndex, 1);
        updated[qIndex].answers.forEach((a, idx) => (a.orderNumber = idx + 1));
        setFormQuiz({ ...formQuiz, questions: updated });
    };

    const isQuizInvalid = () => {
        if (!exercise?.title?.trim()) return true; // empty title

        if (!exercise?.description?.trim()) return true;

        // must have at least one question
        if (!formQuiz?.questions || formQuiz.questions.length === 0) return true;

        return formQuiz.questions.some((q: any) => {
            if (!q.questionText?.trim()) return true; // empty question

            // check if any answer is empty
            if (!q.answers || q.answers.length === 0) return true;
            if (q.answers.some((a: any) => !a.answerText?.trim())) return true;

            // check if at least one isCorrect
            if (!q.answers.some((a: any) => a.isCorrect)) return true;

            return false;
        });
    };

    const handleSavePractice = async () => {
        try {
            setShowPleasewait(true);

            let exerciseIdNum: number;
            let quizIdNum: number;

            const exercisePayload = {
                ...exercise,
                videoRelatedExercises:
                    exercise.videoIds?.map((vId) => ({
                        subLessonId: exercise.subLessonId,
                        exerciseId: exercise.id ?? 0,
                        videoId: vId,
                    })) ?? [],
                contentRelatedExercises:
                    exercise.contentIds?.map((cId) => ({
                        subLessonId: exercise.subLessonId,
                        exerciseId: exercise.id ?? 0,
                        contentId: cId,
                        contentUrl: "string",
                    })) ?? [],
            };

            const practiceData = await post_Practice(exercisePayload, Number(userId))
            exerciseIdNum = typeof practiceData === "number" ? practiceData : practiceData?.id;

            const quizToSave = {
                ...formQuiz,
                questions: formQuiz.questions.map(q => ({
                    ...q,
                    _uid: undefined, // remove _uid
                    answers: q.answers.map(a => ({
                        ...a,
                        _uid: undefined, // remove _uid
                    })),
                })),
            };


            const quizPayload = {
                ...quizToSave,
                title: exercise.title,
                subLessonId: exercise.subLessonId,
            };

            const quizeData = await post_Quize(quizPayload, Number(userId))
            quizIdNum = typeof quizeData === "number" ? quizeData : quizeData?.id;


            const quizRelationPayload = {
                subLessonId: exercise.subLessonId,
                exerciseId: exerciseIdNum,
                quizId: quizIdNum,
            };

            await post_QuizRelatedExcerices(quizRelationPayload, Number(userId));
            setShowPleasewait(false);
            setShowPopup(false);
            setRefreshPracticeList(true);
        } catch (err) {
            console.error("❌ Error saving practice with quiz:", err);
        } finally {
            setShowPleasewait(false);
            setShowPopup(false);
            setRefreshPracticeList(true);
        }
    }

    return (
        <>
            <div className="fixed inset-0 z-[9999999] flex items-center justify-center bg-black/50 p-10">
                <div className="bg-white w-full max-w-5xl rounded-md shadow-lg max-h-[90vh] flex flex-col overflow-auto overscroll-contain">
                    <div className="px-6 py-4 border-b w-full flex justify-between items-center">
                        <h2 className="text-lg font-medium">Add Practice</h2>
                        <button
                            onClick={() => {
                                setShowPopup(false)
                            }}
                            className="text-gray-500"
                        >
                            <span className="material-symbols-outlined text-2xl">
                                close
                            </span>
                        </button>
                    </div>

                    <div className="px-6 py-4">
                        <div className="mb-6">
                            <label className="block mb-1">Title</label>
                            <input
                                type="text"
                                value={exercise.title}
                                onChange={(e) => setExercise({ ...exercise, title: e.target.value })}
                                className="w-full p-2 border rounded mb-4"
                            />
                            <label className="block mb-1">Description</label>
                            <textarea
                                value={exercise.description}
                                onChange={(e) => setExercise({ ...exercise, description: e.target.value })}
                                className="w-full p-2 border rounded mb-4"
                            />
                            <label className="block mb-1">Assign Videos</label>
                            <Select
                                isMulti
                                options={videoOptions}
                                value={videoOptions.filter((v) => exercise.videoIds?.includes(v.value))}
                                onChange={(selected: any) => setExercise({ ...exercise, videoIds: selected ? selected.map((s: any) => s.value) : [] })}
                            />
                            <label className="block mt-4 mb-1">Assign Contents</label>
                            <Select
                                isMulti
                                options={contentOptions}
                                value={contentOptions.filter((c) => exercise.contentIds?.includes(c.value))}
                                onChange={(selected: any) => setExercise({ ...exercise, contentIds: selected ? selected.map((s: any) => s.value) : [] })}
                            />
                        </div>
                        <div className="mt-8 border-t pt-6">
                            <h2 className="text-xl font-bold mb-4">Practice Quiz</h2>

                            <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleQuestionDragEnd}>
                                <SortableContext items={formQuiz.questions.map(q => q._uid)} strategy={verticalListSortingStrategy}>
                                    {formQuiz.questions.map((q, qIndex) => (
                                        <SortableItem key={q._uid} id={q._uid}>
                                            <div className="w-full mb-4 border-l-4 border-primary p-4 rounded shadow-md bg-white">
                                                <div className="md:flex items-center gap-2 mb-2">
                                                    <QuestionInput
                                                        qindex={qIndex}
                                                        value={q.questionText}
                                                        onCommit={(val: string) => handleQuestionChange(qIndex, val)}
                                                    />
                                                    <select
                                                        value={q.questioType}
                                                        onChange={(e) => {
                                                            const updated = [...formQuiz.questions];
                                                            updated[qIndex].questioType = e.target.value;
                                                            setFormQuiz(prev => ({ ...prev, questions: updated }));
                                                        }}
                                                        className="border p-2 rounded bg-white text-sm max-md:mt-2"
                                                    >
                                                        <option value="SingleChoice">Single Choice</option>
                                                        <option value="MultipleChoice">Multiple Choice</option>
                                                    </select>
                                                    <button
                                                        className="text-red-500 hover:text-red-600 cursor-pointer rounded-full w-8 h-8"
                                                        onClick={() => deleteQuestion(qIndex)}
                                                    >
                                                        <span className="material-symbols-outlined text-xl">delete</span>
                                                    </button>
                                                </div>

                                                {/* Answers DnD: separate context */}
                                                <DndContext
                                                    sensors={sensors}
                                                    collisionDetection={closestCenter}
                                                    onDragEnd={(e) => handleAnswerDragEnd(e, qIndex)}
                                                >
                                                    <SortableContext items={q.answers.map(a => a._uid)} strategy={verticalListSortingStrategy}>
                                                        {q.answers.map((a, aIndex) => (
                                                            <SortableItem key={a._uid} id={a._uid}>
                                                                <AnswerInput
                                                                    aindex={aIndex}
                                                                    value={a.answerText}
                                                                    questionType={q.questioType}
                                                                    isCorrect={a.isCorrect}
                                                                    onCommit={(val: string) => handleAnswerChange(qIndex, aIndex, val)}
                                                                    onToggleCorrect={() => toggleAnswerCorrect(qIndex, aIndex)}
                                                                />
                                                                <button
                                                                    className="text-red-500 hover:text-red-600 cursor-pointer rounded-full w-8 h-8"
                                                                    onClick={() => deleteAnswer(qIndex, aIndex)}
                                                                >
                                                                    <span className="material-symbols-outlined text-xl">delete</span>
                                                                </button>
                                                            </SortableItem>
                                                        ))}
                                                    </SortableContext>
                                                </DndContext>

                                                <div className="mt-2 space-y-3">
                                                    <button
                                                        onClick={() => addAnswer(qIndex)}
                                                        className="px-2 py-1 bg-green-500 text-white rounded"
                                                    >
                                                        + Add Answer
                                                    </button>

                                                    <div>
                                                        <label className="block text-sm text-gray-600 mb-1">Explanation Text</label>
                                                        <textarea
                                                            value={q.explanationText}
                                                            onChange={(e) => {
                                                                const updated = [...formQuiz.questions];
                                                                updated[qIndex].explanationText = e.target.value;
                                                                setFormQuiz((prev) => ({ ...prev, questions: updated }));
                                                            }}
                                                            placeholder="Enter explanation for this question..."
                                                            className="w-full p-2 border rounded bg-white min-h-[100px]"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </SortableItem>
                                    ))}
                                </SortableContext>
                            </DndContext>

                            <button onClick={addQuestion} className="px-3 py-1 bg-primary text-white rounded mt-4 text-sm">
                                + Add Question
                            </button>
                        </div>
                    </div>



                    <div className="px-6 py-4 border-t flex justify-end space-x-3">

                        <button
                            className={`px-6 py-2 ${isQuizInvalid()
                                ? "bg-gray-300 text-white cursor-not-allowed"
                                : "bg-primary text-white cursor-pointer"
                                } font-medium rounded`}
                            disabled={isQuizInvalid()}
                            onClick={handleSavePractice}
                        >
                            Save
                        </button>
                    </div>
                </div>
            </div >
            <PleasewaitPopup showPopup={showPleasewait} />
        </>
    )
}